// extracted by mini-css-extract-plugin
export default {"clientContent":"client-content_clientContent__I+Q3G"};